import { useNavigate, useParams } from "react-router-dom"
import { Box, Container } from "@mui/material"
import { useContext, useEffect } from "react"

import SplashScreenGuard from "../../../router/guards/SplashScreenGuard"
import { logLandingPageAction } from "../../../clients/logger"
import LocalStorageKeys from "../../../types/LocalStorageKeys"
import { MyInfoReason } from "../../../types/MyInfoUserData"
import { UserContext } from "../../../stores/User/UserStore"
import { Route, STRAPI_URL } from "../../../router"
import SignUpButton from "../../atoms/SignUpButton/SignUpButton"
import useTrackPageView from "../../../helpers/hooks/use-track-page-view"
import useGoogleTagManager from '../../../helpers/analytics/use-google-tag-manager'
import GtmEventName from '../../../helpers/analytics/GtmEventName'

import styles from "./ReferralLandingPage.module.css"
import { useReferralLandingPageRepository } from "../../../repositories/ReferralLandingPage/use-referral-landing-page.repository"
import { AppContext } from "../../../stores/App/AppStore"
import MarkdownContent from "../../atoms/MarkdownContent/MarkdownContent"
import PartnerOrPlanLandingPageSkeleton from "../PartnerOrPlanLandingPage/PartnerOrPlanLandingPage.skeleton"
import ReferralRepeatableContent from "../../molecules/ReferralRepeatableContent/ReferralRepeatableContent"

const ReferralLandingPage = () => {
    const { referralCode } = useParams()
    const { trackButtonClick } = useGoogleTagManager()

    const navigate = useNavigate()
    const { setReferralCode, getReferralPage } = useReferralLandingPageRepository()
    const { state: userState } = useContext(UserContext)
    const { state: appState } = useContext(AppContext)

    const membership = userState.membership?.data

    useEffect(() => {
        getReferralPage()
        if (membership) {
            navigate(Route.HOME)
        }
    }, [])

    useTrackPageView(() => {
        if (referralCode) {
            return {
                title: `Referral Code Landing Page`,
                item: referralCode,
            }
        }
    }, [referralCode])

    useEffect(() => {
        if (referralCode) {
            setReferralCode(referralCode)
        }
    }, [referralCode])

    const handleSignUpButtonClick = () => {
        trackButtonClick(GtmEventName.SIGN_UP_CLICK, referralCode)
        localStorage.setItem(LocalStorageKeys.MYINFO_REASON, MyInfoReason.SIGNUP)
        logLandingPageAction(`Sign Up`, `referralLanding`, referralCode)
        window.location.href = `${STRAPI_URL}${Route.MYINFO_AUTHORISE}`
    }

    if (!appState.pages.referralLandingPage.landingPageDescription || !appState.pages.referralLandingPage.landingPageTitle) {
        return (
            <SplashScreenGuard>
                <PartnerOrPlanLandingPageSkeleton />
            </SplashScreenGuard>
        )
    }

    return (
        <SplashScreenGuard>
            <Container>
                <Box>
                    <MarkdownContent content={appState.pages.referralLandingPage.landingPageTitle} className={styles.title} />
                    <MarkdownContent content={appState.pages.referralLandingPage.landingPageDescription} className={styles.content}/>
                    <ReferralRepeatableContent repeatableContent={appState.pages.referralLandingPage.landingPageRepeatableContent ?? []}></ReferralRepeatableContent>
                </Box>
                <Box className={styles.bottomButtons}>
                    <SignUpButton onClick={handleSignUpButtonClick} />
                </Box>
            </Container>
        </SplashScreenGuard>
    )
}

export default ReferralLandingPage